import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import { connect } from "react-redux";
import * as moment from "moment";
import { Image } from "hesus-ui-kit";
import axios from "axios";
import "./LanguageSelection.scss";

const LanguageSelection = (props) => {
  const { t, languageList } = props;
  const initLng = i18next.language;
  const { divClassName, userCountry } = props;

  const [isLangChanged, setLanguageChange] = useState({
    id: "",
    updated: false,
  });

  useEffect(() => {
    const locale = localStorage.getItem("locale");
    let lng;
    // let countryId;
    if (!isLangChanged) {
      setLanguageChange({ id: "", updated: false });
    }
    if (locale === null || locale !== initLng) {
      const selectedLanguageInfo = languageList.find(
        (language) => language.lang === initLng
      );
      lng = selectedLanguageInfo.lang;
      setLanguageChange({ id: selectedLanguageInfo.id, updated: true });
      localStorage.setItem("locale", lng);
    } else {
      lng = locale;
      const selectedLanguageInfo = languageList.find(
        (language) => language.lang === lng
      );
      setLanguageChange({ id: selectedLanguageInfo.id, updated: true });
    }
    moment.locale(lng);
    i18next.changeLanguage(lng);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const changeLanguage = (id, lng) => {
    const languageSelected = languageList.find(
      (language) => language.id === id
    );
    setLanguageChange({ id: languageSelected.id, updated: true });
    moment.locale(lng);
    localStorage.setItem("locale", lng);
    i18next.changeLanguage(lng);
    axios.get(`/change_language/${id}`, {
      headers: {
        Accept: "application/json",
      },
    });
  };

  return (
    <div className={divClassName}>
      <div>
        <button
          className="dropdown-toggle border-0"
          id="translateLang"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          type="button"
        >
          <div className="rounded-circle d-inline-block flag-div bottom-lang">
            {languageList &&
              !isLangChanged.updated &&
              languageList
                .filter((x) => x.lang === localStorage.getItem("locale"))
                .map((item) => (
                  <div key={item.id}>
                    {item.id}
                    <Image
                      // key={item.id}
                      src={item.flag}
                      title={item.title}
                      className="flag crsr-ptr"
                      styles={{ width: "16px", heigth: "16px" }}
                      alt="flag"
                    />
                  </div>
                ))}
            {isLangChanged.updated &&
              languageList
                .filter(
                  (x) => parseInt(x.id, 10) === parseInt(isLangChanged.id, 10)
                )
                .map((item) => (
                  <Image
                    key={item.id}
                    src={item.flag}
                    title={item.title}
                    className="flag crsr-ptr"
                    styles={{ width: "35px", heigth: "35px" }}
                    alt="flag"
                  />
                ))}
          </div>
        </button>
        <div
          className="navbar-flag-dropdown-menu"
          aria-labelledby="translateLang"
        >
          <ul className="m-0 p-0 flag-dropdown-menu-list">
            {languageList &&
              languageList.map((item) => (
                <li
                  key={item.id + item.lang}
                  className="dropdown-item"
                  onClick={() => {
                    changeLanguage(item.id, item.lang);
                  }}
                >
                  <Image
                    key={item.id}
                    src={item.flag}
                    title={item.title}
                    className="flag crsr-ptr"
                    alt="flag"
                  />
                </li>
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(LanguageSelection);
